/**
 * RESPONSIBILITY: draw the About page's opening statement, inside the patterned frame.
 *
 * The frame is the home page's welcome border — one rule, `.pattern-frame`, shared by both
 * — so the two places the church says who it is look like the same voice.
 *
 * The letters are drawn only when there are some, and each is set large beside its words
 * so the name reads down the column: A, C, F, I.
 */
import { idOf } from '@framework/core';
import type { AboutEstablishedSection } from '@app/sections';

export function AboutEstablished({ c }: { c: AboutEstablishedSection }) {
  const letters = (c.letters ?? []).filter((l) => l.letter?.trim());
  if (!c.heading && !c.intro && !c.whoBody && letters.length === 0) return null;

  return (
    <section className="band about-est">
      <div className="wrap">
        <div className="pattern-frame">
          <div className="about-est-card">
            {c.heading && <h2 className="about-est-title">{c.heading}</h2>}
            {c.intro && <p className="about-est-lede">{c.intro}</p>}

            {(c.whoHeading || c.whoBody || letters.length > 0) && (
              <div className="about-est-who">
                <div className="about-est-words">
                  {c.whoHeading && <h3>{c.whoHeading}</h3>}
                  {c.whoBody && <p>{c.whoBody}</p>}
                </div>
                {letters.length > 0 && (
                  <ol className="about-est-letters">
                    {letters.map((l, i) => (
                      <li key={idOf(l) || i}>
                        <span className="about-est-letter" aria-hidden="true">{l.letter}</span>
                        <span className="about-est-meaning">{l.meaning}</span>
                      </li>
                    ))}
                  </ol>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
